'use strict';

exports.__esModule = true;
var _environment = void 0;

var isTest = function isTest() {
  return _environment === 'test';
};

var isProduction = function isProduction() {
  return _environment === 'prod';
};

var isDevelopment = function isDevelopment() {
  return !isProduction() && !isTest();
};

var getEnvName = function getEnvName() {
  // Use cached environment if available
  return _environment;
};

var _isDebug = false;

var isDebug = function isDebug() {
  return _isDebug;
};

var setDebug = function setDebug(debug) {
  _isDebug = debug === true || debug === 'true';
};

var init = function init(environment) {
  _environment = environment;
};

var _clearEnv = function _clearEnv() {
  _environment = undefined;
};

exports.isDebug = isDebug;
exports.isDevelopment = isDevelopment;
exports.isProduction = isProduction;
exports.isTest = isTest;
exports.setDebug = setDebug;
exports.init = init;
exports.getEnvName = getEnvName;

// test exports

exports._clearEnv = _clearEnv;